import { resource, RequestConfig } from '../helper/resource';

/**
 * [Auth]买卖点
 */
export function queryBuyAndSellPointUsingPOST(
  req: InfoCodeClientDto | void,
  config?: RequestConfig
): Promise<ApiResultListLcBuySellPoint> {
  return resource.post('/queryBuyAndSellPoint', req, config);
}

/**
 * [No Auth]各种基金基本信息
 */
export function queryFundBaseInfoUsingPOST(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultFundInfoDto> {
  return resource.postNoAuth('/queryFundBaseInfo', req, config);
}

/**
 * [No Auth]基金档案外部
 */
export function queryFundInfoUsingPOST(req: InfoCodeDto | void, config?: RequestConfig): Promise<ApiResultFundInfoDto> {
  return resource.postNoAuth('/queryFundInfo', req, config);
}

/**
 * [No Auth]基金经理
 */
export function queryFundManagerInfoUsingPOST(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultListFundManagerInfoDto> {
  return resource.postNoAuth('/queryFundManagerInfo', req, config);
}

/**
 * [No Auth]基金页面类型
 */
export function queryFundPageTypeUsingPOST_1(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultFundPageTypeDto> {
  return resource.postNoAuth('/queryFundPageType', req, config);
}

/**
 * [No Auth]产品概要
 */
export function queryFundProfileUsingPOST(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultLcAnnouncement> {
  return resource.postNoAuth('/queryFundProfile', req, config);
}

/**
 * [No Auth]产品宣传图链接
 */
export function queryPublicityPictureUrlUsingPOST(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultstring> {
  return resource.postNoAuth('/queryPublicityPictureUrl', req, config);
}

/**
 * [No Auth]阅读文件留痕
 */
export function addFundLeaveMarksUsingPOST(req: LcFundLeaveMarks | void, config?: RequestConfig): Promise<void> {
  return resource.postNoAuth('/saveFundLeaveMarks', req, config);
}

/**
 * [No Auth]根据产品代码查询产品文件路径
 */
export function searchFindFileUsingPOST(
  req: SearchFindFileParam | void,
  config?: RequestConfig
): Promise<ApiResultListLcFundFilePathVo> {
  return resource.postNoAuth('/searchFindFile', req, config);
}
/**
 * [No Auth]根据产品代码查询R5产品文件路径
 */
export function searchFindR5FileUsingPOST(
  req: SearchFindFileParam | void,
  config?: RequestConfig
): Promise<ApiResultListLcFundFilePathVo> {
  return resource.postNoAuth('/searchFindFileForR5', req, config);
}
